export enum ACTION_TYPES {
  UPDATE_SUBPAGE_DIRTY = 'CM/SUB_PAGES/UPDATE_SUBPAGE_DIRTY',
  UPDATE_APPLICANT_SUBPAGE_DIRTY = 'CM/SUB_PAGES/UPDATE_APPLICANT_SUBPAGE_DIRTY',
}

export enum SUBPAGES {
  LOAN_DETAILS = 'LOAN_DETAILS',
  PROPERTY = 'PROPERTY',
  REPAYMENT_STRATEGY = 'REPAYMENT_STRATEGY',
  ADMIN = 'ADMIN',
  LIFE_ASSURANCE = 'LIFE_ASSURANCE',
  APPLICANTS = 'APPLICANTS',
  APPLICANT_PERSONAL_DETAILS = 'APPLICANT_PERSONAL_DETAILS',
  APPLICANT_VULNERABILITY = 'APPLICANT_VULNERABILITY',
  APPLICANT_EMPLOYMENT = 'APPLICANT_EMPLOYMENT',
  APPLICANT_ASSETS = 'APPLICANT_ASSETS',
  APPLICANT_INCOME_CURRENT = 'APPLICANT_INCOME_CURRENT',
  APPLICANT_INCOME_FUTURE = 'APPLICANT_INCOME_FUTURE',
  APPLICANT_PENSIONS_CURRENT = 'APPLICANT_PENSIONS_CURRENT',
  APPLICANT_PENSIONS_FUTURE = 'APPLICANT_PENSIONS_FUTURE',
  APPLICANT_EXPENDITURES = 'APPLICANT_EXPENDITURES',
  RATIONALE = 'RATIONALE',
}

export interface TSubPage {
  isDirty: boolean;
}

export interface TSubPages {
  [SUBPAGES.LOAN_DETAILS]: TSubPage;
  [SUBPAGES.PROPERTY]: TSubPage;
  [SUBPAGES.REPAYMENT_STRATEGY]: TSubPage;
  [SUBPAGES.ADMIN]: TSubPage;
  [SUBPAGES.LIFE_ASSURANCE]: TSubPage;
  [SUBPAGES.REPAYMENT_STRATEGY]: TSubPage;
  [SUBPAGES.RATIONALE]: TSubPage;
  [SUBPAGES.APPLICANTS]: Array<{
    [SUBPAGES.APPLICANT_PERSONAL_DETAILS]: TSubPage;
    [SUBPAGES.APPLICANT_VULNERABILITY]: TSubPage;
    [SUBPAGES.APPLICANT_EMPLOYMENT]: TSubPage;
    [SUBPAGES.APPLICANT_ASSETS]: TSubPage;
    [SUBPAGES.APPLICANT_INCOME_CURRENT]: TSubPage;
    [SUBPAGES.APPLICANT_INCOME_FUTURE]: TSubPage;
    [SUBPAGES.APPLICANT_PENSIONS_CURRENT]: TSubPage;
    [SUBPAGES.APPLICANT_PENSIONS_FUTURE]: TSubPage;
    [SUBPAGES.APPLICANT_EXPENDITURES]: TSubPage;
  }>;
}
